import { ZENDESK_KEY } from '@/constants';
import Script from 'next/script';

declare let zE: any;

function ZenDeskScript() {
  return (
    <Script
      id="ze-snippet"
      type="text/javascript"
      src={`https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`}
      async
      defer
      onLoad={() => {
        zE('messenger:set', 'zIndex', -999999);
        zE('messenger:on', 'close', () => {
          setTimeout(() => {
            zE('messenger:set', 'zIndex', -999999);
          }, 500);
        });
        zE('messenger:on', 'open', () => {
          setTimeout(() => {
            zE('messenger:set', 'zIndex', 999999);
          }, 100);
        });
      }}
    />
  );
}

export default ZenDeskScript;
